class IglBuy extends HTMLElement {
  connectedCallback() {
    this.abort = new AbortController();
    this.addEventListener('command', event => {
      if (event.command !== '--buy') return;
      const form = this.closest('main')?.querySelector('#igl-purchase-form');
      const button = form?.querySelector('button[name="add"]');
      if (button && button.getAttribute('aria-disabled') !== 'true') form.requestSubmit(button);
      else this.closest('main')?.querySelector('#purchase-panel')?.scrollIntoView({ block: 'center' });
    }, { signal: this.abort.signal });
  }
  disconnectedCallback() { this.abort?.abort(); }
}
customElements.define('igl-buy', IglBuy);
